import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StepsLayout, {
  TypeLayout
} from 'screens/Applications&WorkOrders/StepsLayout';
import { useAuth } from 'utilities/base-auth';
import { FormValues as ApplicationFormValues } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

import { Plan, PlanProductEntry } from 'screens/Plans/ConvertPlanModalV2/types';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import { convertPlanToOperationFormikData } from './helpers';
import useCropZonesFromPlan from './hooks/useCropZonesFromPlan';
import useProductsFromPlan from './hooks/useProductsFromPlan';

export const CreateOperationFromPlan: React.FC = () => {
  const { state } = useLocation<{
    plan: Plan;
    selectedProducts: PlanProductEntry[];
    operationType: OperationType;
  }>();
  const { plan, selectedProducts, operationType } = state || {
    operationType: OperationType.APPLICATION,
    plan: undefined,
    selectedProducts: []
  };
  const { setValues } = useFormikContext<ApplicationFormValues>();

  const {
    mappedCropZones,
    isMappingCropZones,
    isPropertiesLoading
  } = useCropZonesFromPlan({
    plan
  });

  const { mappedProducts, isMappingProducts } = useProductsFromPlan({
    selectedProducts,
    plan
  });

  const { user } = useAuth();

  const isLoading =
    isPropertiesLoading || isMappingCropZones || isMappingProducts;

  useEffect(() => {
    if (plan?.id) {
      const totalAppliedArea =
        mappedCropZones?.reduce(
          (sum, cz) => sum + (cz.appliedAcreage || 0),
          0
        ) || 0;

      setValues(
        convertPlanToOperationFormikData(
          plan,
          mappedCropZones,
          mappedProducts,
          totalAppliedArea,
          user
        )
      );
    }
  }, [
    plan,
    setValues,
    user,
    selectedProducts,
    mappedCropZones,
    mappedProducts
  ]);

  const type =
    operationType === OperationType.APPLICATION
      ? TypeLayout.APPLICATION
      : TypeLayout.WORK_ORDER;

  return <StepsLayout isLoading={isLoading} type={type} />;
};

export default CreateOperationFromPlan;
